// extracted by mini-css-extract-plugin
export var active = "_5r-a";
export var activeIndicator = "_5r-9";
export var disabled = "_5r-b";
export var fullWidth = "_5r-2";
export var lg = "_5r-7";
export var md = "_5r-6";
export var redoButtonTabGroup = "_5r-0";
export var sm = "_5r-5";
export var tabButton = "_5r-4";
export var tabButtonsContainer = "_5r-1";
export var themeDestructive = "_5r-d";
export var themeNormal = "_5r-c";
export var themeSuccess = "_5r-e";
export var xl = "_5r-8";
export var xs = "_5r-3";